
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging/hospitality",
      function () {
        return require("private-next-pages/evcharging/hospitality.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging/hospitality"])
      });
    }
  